// extracted by mini-css-extract-plugin
module.exports = {"u_skip":"MyhouseMainResidentList_u_skip__cjb-E","blind":"MyhouseMainResidentList_blind__3Y8zO","hidden":"MyhouseMainResidentList_hidden__2-kDV"};